import { render, staticRenderFns } from "./DeletePurchaseRequest.vue?vue&type=template&id=1dfd3134&"
import script from "./DeletePurchaseRequest.vue?vue&type=script&lang=ts&"
export * from "./DeletePurchaseRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports